<template>
    <transition
        enter-active-class="ease-out duration-500"
        enter-from-class="opacity-0 max-h-0"
        enter-to-class="opacity-100 max-h-screen"
        leave-active-class="ease-in duration-300"
        leave-from-class="opacity-100 max-h-screen"
        leave-to-class="opacity-0 max-h-0"
        ><div
            v-if="showForm"
            class="rounded-t-2xl bg-white w-screen flex flex-col justify-between"
            :style="{ height: cardHeight + 'px' }"
        >
            <div class="flex flex-col gap-4">
                <div v-if="icon || title" class="pt-6 px-4 flex flex-col gap-4">
                    <CircleIconWrapper v-if="icon" class="max-w-max p-2.5 m-2"
                        ><component
                            :is="icon"
                            class="w-8 h-8" /></CircleIconWrapper
                    ><span
                        v-if="title"
                        class="text-h1 leading-8 font-noto font-bold"
                        >{{ title }}</span
                    >
                </div>

                <Divider v-if="icon || title" />
                <div class="pt-4 px-4">
                    <slot />
                </div>
            </div>
            <div v-if="showCTA">
                <Divider />
                <div class="p-4">
                    <ButtonWrapper
                        class="w-full"
                        color="promo"
                        :disabled="ctaDisabled"
                        :processing="processing"
                        @click="submit"
                        >{{ ctaText }}</ButtonWrapper
                    >
                </div>
            </div>
        </div></transition
    >
</template>

<script setup>
import ButtonWrapper from "@/Components/Buttons/ButtonWrapper.vue";
import CircleIconWrapper from "@/Components/Icons/CircleIconWrapper.vue";
import Divider from "@/Components/Divider.vue";
import { ref, onMounted, onUnmounted } from "vue";

const props = defineProps({
    title: {
        type: String,
        default: null,
    },
    showCTA: {
        type: Boolean,
        default: true,
    },
    ctaText: {
        type: String,
        default: null,
    },
    icon: {
        type: Object,
        default: null,
    },
    ctaDisabled: {
        type: Boolean,
        default: false,
    },
    processing: {
        type: Boolean,
        default: false,
    },
});

const showForm = ref(false);
const emit = defineEmits(["confirm"]);
const cardHeight = ref(0);

onMounted(() => {
    showForm.value = true;
    resizeHandler();
    window.addEventListener("resize", resizeHandler);
});

onUnmounted(() => {}),
    () => {
        window.removeEventListener("resize", resizeHandler);
    };
const resizeHandler = () => {
    const header = document.getElementById("simpleHeader");
    const headerHeight = header ? header.clientHeight : 0;
    cardHeight.value = window.innerHeight - headerHeight - 12;
};

const submit = () => {
    emit("confirm");
};
</script>
